import React, { HTMLAttributes, ReactNode } from "react";
import Icon from "../icon/Icon";
import Styles from "./CallToAction.module.scss";
import Text from "../text/Text";

export interface CallToActionProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
    title: ReactNode;
    icon?: ReactNode;
    text?: ReactNode;
    children?: ReactNode;
    actions?: ReactNode;
    image?: ReactNode;
}

const CallToAction = React.forwardRef((
    args: CallToActionProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactNode => {
    const {
        title,
        icon,
        text,
        actions,
        image,
        children,
        ...rest
    } = args;
    return (
        <div className={Styles.cta} ref={ref} {...rest}>
            <div className={Styles["cta-content"]}>
                {icon}
                <Text as="h2" textVariant="subtitle-2">{title}</Text>

                <Text as="p" textVariant="body-2-regular" colorVariant="body-secondary">{text ?? children}</Text>

                {actions && (
                    <div className={Styles["cta-actions"]}>
                        {actions}
                    </div>
                )}
            </div>
            {image && (
                <div className={Styles["cta-image"]}>
                    {image}
                </div>
            )}

        </div>
    );
});

CallToAction.defaultProps = {
    title: undefined,
    icon: undefined,
    text: undefined,
    actions: undefined,
};

export default CallToAction;
